import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function flatCheckboxGroupsToItems(groups) {
  return groups.reduce(function (accumulator, group) {
    accumulator.push.apply(accumulator, _toConsumableArray(group.items));
    return accumulator;
  }, Array.of());
}